// extracted by mini-css-extract-plugin
export var button = "_13-1";
export var featuredLink = "_13-4";
export var spinner = "_13-2";
export var spinnerContainer = "_13-3";
export var text = "_13-0";